import React from 'react';

const AudienceBriefModal = ({ state }) => {
  const {
    showAudienceBrief,
    audienceBriefData,
    setShowAudienceBrief,
    setAudienceBriefData,
    selectedTrend,
    setGeneratedBriefs,
    setNotification,
  } = state;

  if (!showAudienceBrief || !audienceBriefData) return null;

  const sendToAudienceQueue = () => {
    // Track the brief generation
    const newBriefRecord = {
      id: Date.now(),
      trendId: selectedTrend?.id,
      trend: selectedTrend?.signal,
      macro: selectedTrend?.macro,
      briefTypes: ['audience'],
      contentBrief: null,
      audienceBrief: { status: 'sent', destination: 'audience_queue', sentAt: new Date().toLocaleString() },
      createdAt: new Date().toLocaleDateString()
    };
    setGeneratedBriefs(prev => {
      // Check if we already have a record for this trend
      const existing = prev.find(b => b.trendId === selectedTrend?.id);
      if (existing) {
        return prev.map(b => b.trendId === selectedTrend?.id
          ? { ...b, briefTypes: [...new Set([...b.briefTypes, 'audience'])], audienceBrief: newBriefRecord.audienceBrief }
          : b
        );
      }
      return [newBriefRecord, ...prev];
    });
    setNotification('Audience Brief sent to Audience queue for Distribution & Engagement teams.');
    setShowAudienceBrief(false);
    setAudienceBriefData(null);
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      zIndex: 1000,
      overflow: 'auto',
      padding: '40px 20px'
    }}>
      <div style={{
        backgroundColor: '#1e1e32',
        borderRadius: 16,
        width: '100%',
        maxWidth: 900,
        border: '1px solid #2d2d44'
      }}>
        {/* Header */}
        <div style={{
          padding: '24px 32px',
          borderBottom: '1px solid #2d2d44',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
              <span style={{ fontSize: 24 }}>{'\uD83D\uDCCA'}</span>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: '600', color: '#f3f4f6' }}>{audienceBriefData.title}</h2>
            </div>
            <div style={{ display: 'flex', gap: 16, fontSize: 12, color: '#9ca3af' }}>
              <span>Priority: <span style={{ color: audienceBriefData.priority === 'High' ? '#ef4444' : audienceBriefData.priority === 'Medium' ? '#f59e0b' : '#6b7280', fontWeight: '500' }}>{audienceBriefData.priority}</span></span>
              <span>Generated: {audienceBriefData.generatedAt}</span>
            </div>
          </div>
          <button
            onClick={() => { setShowAudienceBrief(false); setAudienceBriefData(null); }}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              fontSize: 28,
              cursor: 'pointer',
              lineHeight: 1
            }}
          >
            {'\u00D7'}
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: 32, maxHeight: 'calc(100vh - 250px)', overflow: 'auto' }}>
          {/* Audience Segments */}
          <div style={{ marginBottom: 32 }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>{'\uD83D\uDC65'}</span> Audience Segments
            </h3>
            <div style={{ display: 'grid', gap: 16 }}>
              {audienceBriefData.audienceSegments.map((segment, idx) => (
                <div key={idx} style={{
                  padding: 20,
                  backgroundColor: '#252540',
                  borderRadius: 12,
                  borderLeft: `4px solid ${idx === 0 ? '#10b981' : idx === 1 ? '#3b82f6' : '#8b5cf6'}`
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                    <div>
                      <h4 style={{ margin: '0 0 4px', fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>{segment.name}</h4>
                      <p style={{ margin: 0, fontSize: 13, color: '#9ca3af' }}>{segment.description}</p>
                    </div>
                    <span style={{ padding: '4px 10px', backgroundColor: '#10b98120', borderRadius: 4, fontSize: 12, color: '#10b981', fontWeight: '500' }}>
                      {segment.size}
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: 24, fontSize: 12 }}>
                    <div>
                      <span style={{ color: '#6b7280' }}>Platforms: </span>
                      <span style={{ color: '#d1d5db' }}>{segment.platforms.join(', ')}</span>
                    </div>
                    <div>
                      <span style={{ color: '#6b7280' }}>Affinities: </span>
                      <span style={{ color: '#d1d5db' }}>{segment.affinities.join(', ')}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Channel Strategy */}
          <div style={{ marginBottom: 32 }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>{'\uD83D\uDCE1'}</span> Channel Strategy
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
              {audienceBriefData.channelStrategy.map((channel, idx) => (
                <div key={idx} style={{
                  padding: 20,
                  backgroundColor: '#252540',
                  borderRadius: 12
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <h4 style={{ margin: 0, fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>{channel.channel}</h4>
                    <span style={{
                      padding: '3px 8px',
                      borderRadius: 4,
                      fontSize: 10,
                      fontWeight: '600',
                      backgroundColor: channel.priority === 'High' ? '#ef444420' : channel.priority === 'Medium' ? '#f59e0b20' : '#6b728020',
                      color: channel.priority === 'High' ? '#ef4444' : channel.priority === 'Medium' ? '#f59e0b' : '#9ca3af'
                    }}>
                      {channel.priority} Priority
                    </span>
                  </div>
                  <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 12 }}>
                    <strong style={{ color: '#d1d5db' }}>Tactics:</strong> {channel.tactics.join(' \u2022 ')}
                  </div>
                  {channel.keywords && (
                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>
                      Keywords: {channel.keywords.slice(0, 3).join(', ')}
                    </div>
                  )}
                  {channel.estimatedReach && (
                    <div style={{ fontSize: 12, color: '#10b981' }}>{channel.estimatedReach}</div>
                  )}
                  {channel.recommendedBudget && (
                    <div style={{ fontSize: 12, color: '#f59e0b' }}>Budget: {channel.recommendedBudget}</div>
                  )}
                  {channel.estimatedAudience && (
                    <div style={{ fontSize: 12, color: '#3b82f6' }}>{channel.estimatedAudience}</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Engagement Strategy */}
          <div style={{ marginBottom: 32 }}>
            <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>{'\uD83C\uDFAF'}</span> Engagement Strategy
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
              {/* Onsite */}
              <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
                <h4 style={{ margin: '0 0 12px', fontSize: 13, fontWeight: '600', color: '#f59e0b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Onsite</h4>
                {audienceBriefData.engagementStrategy.onsite.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: idx < audienceBriefData.engagementStrategy.onsite.length - 1 ? '1px solid #374151' : 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <span style={{ fontSize: 13, fontWeight: '500', color: '#f3f4f6' }}>{item.tactic}</span>
                      <span style={{ fontSize: 10, color: item.priority === 'High' ? '#10b981' : '#6b7280' }}>{item.priority}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>{item.description}</p>
                  </div>
                ))}
              </div>

              {/* Email */}
              <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
                <h4 style={{ margin: '0 0 12px', fontSize: 13, fontWeight: '600', color: '#3b82f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Email</h4>
                {audienceBriefData.engagementStrategy.email.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: idx < audienceBriefData.engagementStrategy.email.length - 1 ? '1px solid #374151' : 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <span style={{ fontSize: 13, fontWeight: '500', color: '#f3f4f6' }}>{item.tactic}</span>
                      <span style={{ fontSize: 10, color: item.priority === 'High' ? '#10b981' : '#6b7280' }}>{item.priority}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>{item.description}</p>
                  </div>
                ))}
              </div>

              {/* Push */}
              <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
                <h4 style={{ margin: '0 0 12px', fontSize: 13, fontWeight: '600', color: '#8b5cf6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Push Notifications</h4>
                {audienceBriefData.engagementStrategy.push.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: idx < audienceBriefData.engagementStrategy.push.length - 1 ? '1px solid #374151' : 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <span style={{ fontSize: 13, fontWeight: '500', color: '#f3f4f6' }}>{item.tactic}</span>
                      <span style={{ fontSize: 10, color: item.priority === 'High' ? '#10b981' : '#6b7280' }}>{item.priority}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>{item.description}</p>
                  </div>
                ))}
              </div>

              {/* Social */}
              <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
                <h4 style={{ margin: '0 0 12px', fontSize: 13, fontWeight: '600', color: '#10b981', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Social</h4>
                {audienceBriefData.engagementStrategy.social.map((item, idx) => (
                  <div key={idx} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: idx < audienceBriefData.engagementStrategy.social.length - 1 ? '1px solid #374151' : 'none' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                      <span style={{ fontSize: 13, fontWeight: '500', color: '#f3f4f6' }}>{item.tactic}</span>
                      <span style={{ fontSize: 10, color: item.priority === 'High' ? '#10b981' : '#6b7280' }}>{item.priority}</span>
                    </div>
                    <p style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Timing & KPIs */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
            {/* Timing */}
            <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
              <h4 style={{ margin: '0 0 16px', fontSize: 13, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                <span style={{ marginRight: 8 }}>{'\u23F0'}</span> Timing Recommendations
              </h4>
              <div style={{ display: 'grid', gap: 12, fontSize: 12 }}>
                <div>
                  <span style={{ color: '#6b7280' }}>Optimal Publish:</span>
                  <span style={{ color: '#f3f4f6', marginLeft: 8 }}>{audienceBriefData.timing.optimalPublishWindow}</span>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Peak Search Period:</span>
                  <span style={{ color: '#f3f4f6', marginLeft: 8 }}>{audienceBriefData.timing.peakSearchPeriod}</span>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Social Best Times:</span>
                  <span style={{ color: '#f3f4f6', marginLeft: 8 }}>{audienceBriefData.timing.socialBestTimes}</span>
                </div>
                <div>
                  <span style={{ color: '#6b7280' }}>Email Best Days:</span>
                  <span style={{ color: '#f3f4f6', marginLeft: 8 }}>{audienceBriefData.timing.emailBestDays}</span>
                </div>
              </div>
            </div>

            {/* KPIs */}
            <div style={{ padding: 20, backgroundColor: '#252540', borderRadius: 12 }}>
              <h4 style={{ margin: '0 0 16px', fontSize: 13, fontWeight: '600', color: '#f3f4f6', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                <span style={{ marginRight: 8 }}>{'\uD83D\uDCC8'}</span> Success Metrics
              </h4>
              <div style={{ display: 'grid', gap: 10 }}>
                {audienceBriefData.kpis.map((kpi, idx) => (
                  <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12 }}>
                    <span style={{ color: '#9ca3af' }}>{kpi.metric}</span>
                    <span style={{ color: '#10b981', fontWeight: '500' }}>{kpi.target}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div style={{
          padding: '20px 32px',
          borderTop: '1px solid #2d2d44',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <button
            onClick={() => { setShowAudienceBrief(false); setAudienceBriefData(null); }}
            style={{
              backgroundColor: 'transparent',
              color: '#9ca3af',
              border: '1px solid #374151',
              padding: '12px 24px',
              borderRadius: 8,
              fontWeight: '500',
              cursor: 'pointer',
              fontSize: 14
            }}
          >
            Close
          </button>
          <button
            onClick={sendToAudienceQueue}
            style={{
              backgroundColor: '#f59e0b',
              color: '#0f0f1a',
              border: 'none',
              padding: '12px 24px',
              borderRadius: 8,
              fontWeight: '600',
              cursor: 'pointer',
              fontSize: 14,
              display: 'flex',
              alignItems: 'center',
              gap: 8
            }}
          >
            <span>{'\uD83D\uDCE4'}</span>
            Send to Audience Queue
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudienceBriefModal;
